<template>
  <div class="rt-lookup">
    <el-input :disabled="disabled" v-model="inputText" readonly>
      <rt-icon slot="suffix" name="rt-base-lookup" @click="show" />
    </el-input>
    <el-dialog :visible.sync="visible">
      <rt-lookup-view
        ref="lookupView"
        :fetch="fetchRecord"
        @confirm="confirm"
        @remove="remove"
      >
        <el-table-column
          v-for="display in params.displayFields"
          :show-overflow-tooltip="true"
          :key="display.name"
          :prop="display.name"
          :label="display.label"
          :width="display.width"
        />
      </rt-lookup-view>
    </el-dialog>
  </div>
</template>

<script>
import rtLookupView from './rtLookupView';

export default {
  name: 'RtLookup',
  components: {
    rtLookupView
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      filterValue: '',
      inputText: ''
    };
  },
  methods: {
    confirm(val) {
      let idField = this.idField || this.entity + 'id';
      let retValue = {
        id: val[idField],
        name: val[this.nameField]
      };

      if (this.returnFields) {
        var fieldList = this.returnFields.split(',');
        for (let i in fieldList) {
          retValue[fieldList[i]] = val[fieldList[i]];
        }
      }
      this.inputText = retValue.name;
      this.$emit('input', retValue);
      this.visible = false;
    },
    remove(val) {
      this.inputText = '';
      this.$emit('input', {
        id: null,
        logicalName: this.logicalName,
        name: null
      });
      this.visible = false;
    },
    show() {
      if (this.disabled) {
        return;
      }
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.lookupView.loadData();
      });
    },
    fetchRecord(queryValue, pageSize, pageIndex) {
      let params = Object.assign({}, this.params, {
        pageSize,
        pageIndex,
        queryValue
      });
      return this.$lookup.getLookupData(params);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLookup.vue?36a5fb90